import apiConfig from "@/utils/apiConfig";
import {postApi} from "@/utils/callApi"

const CommonApi ={
    insertProfile(fpc, newUser, referrerCode, auth){
        let data = {
            fpc: fpc,
            newUser: newUser,
            referrerCode: referrerCode
        }
        return postApi(apiConfig.activityDomain + apiConfig.insertProfile, auth, null, null, data)
    },

    recordAction(actionId, auth){
        let data = {
            actionId: actionId
        }
        return postApi(apiConfig.activityDomain + apiConfig.recordAction, auth, null, null, data)
    }
}

export default CommonApi